<script lang="ts">
import type { CSSProperties } from 'vue'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'SvgIcon',
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    },
    width: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: [Number, String],
      default: ''
    },
    spin: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const symbolId = computed(() => `#${props.prefix}-${props.name}`)

    function formatSize(size: number | string) {
      return `${String(size).replace('px', '')}px`
    }

    const getStyle = computed((): CSSProperties => {
      const { size, width, height } = props
      let s = formatSize(size)
      let w = s
      let h = s
      if (width && height) {
        w = formatSize(width)
        h = formatSize(height)
      }
      return {
        width: w,
        height: h
      }
    })
    return { symbolId, getStyle }
  }
})
</script>

<template>
  <svg :class="[$attrs.class, spin && 'svg-icon-spin']" :style="getStyle" aria-hidden="true">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<style lang="less" scoped>
.svg-icon-spin {
  animation: loadingCircle 1s infinite linear;
}
</style>
